export default "__VITE_ASSET__B0bN4$7m__"